export const distanceOrTown = (item = {}, postCode = null) => {
  let distance;
  if (!item.dealer) {
    return 'N/A';
  }
  const dealer = item.dealer;

  if (item.distance || postCode) {
    distance = Math.round(item.distance);
    return `${distance} mile${distance > 1 ? 's' : ''} away`;
  }

  return `${dealer.city}, ${dealer.county}`;
};



// WEBPACK FOOTER //
// ./src/Common/distanceOrTown/index.js